<template>
  <el-row class="flex-row">
    <!-- <el-col :span="3" class="flex-col"> -->
      <div class="side-box">
        <div class="project-side">{{ Lang.label.pageClassify }}</div>
        <el-scrollbar>
          <div class="tree-box">
            <sideTree
              ref="sideTree"
              @addSubType="handleAddSubType"
              @editType="handleEditType"
              @deleteType="handleDeleteType"
              @nodeClick="handleTreeNodeClick"
              @editTable="handleEditTable"
              @deleteTable="handleDeleteTable"
              @getData="searchFirstItem"
            >
            </sideTree>
          </div>
        </el-scrollbar>
        <div class="add-box">
          <el-button icon="el-icon-plus" type="default" @click="addType">{{
            Lang.btn.addClassify
          }}</el-button>
        </div>
      </div>
    <!-- </el-col> -->
    <el-col class="flex-col">
      <breadcrumb :repeat="true" v-if="website.setting.breadcrumb" />
      <basic-card hideHeader hidePagination>
        <div class="page-row">
          <div class="page-title">{{ Lang.label.indexDispaly }}</div>
          <div @click="addPage">
            <comp-button icon="icon-add" type="primary">
              {{ Lang.btn.addNew }}
            </comp-button>
          </div>
        </div>
        <div class="page-search">
          <select-input
              :options="[{ label: this.Lang.option.pageName, value: '1', searchKey: 'viewName' }]"
              defaultValue="1"
              @search="searchChange"
            >
            </select-input>
        </div>
        <avue-crud
          class="assemble"
          :option="option"
          v-model:search="search"
          v-model:page="page"
          :table-loading="loading"
          :data="data"
          :permission="permissionObj"
          :before-open="beforeOpen"
          ref="crud"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="refreshChange"
          @on-load="onLoad"
        >
          <template #menu-left>
            
          </template>
          <template #menu="{ row }">
            <el-button type="primary" class="btn-border-right padding-left0" text @click.stop="handleEditPage(row)">{{ Lang.btn.edit }}</el-button>
            <el-button type="primary" class="btn-border-right" text @click.stop="handleDeletePage(row)">{{ Lang.btn.delete }}</el-button>
            <el-button v-if="row.viewData" type="primary" class="btn-border-right" text @click.stop="handleViewDetail(row)">{{ Lang.label.viewPath }}</el-button>
            <el-button type="primary" text @click.stop="handleEditDetail(row)">{{ Lang.label.editPage }}</el-button>
          </template>
        </avue-crud>
      </basic-card>
      <el-dialog :title="Lang.btn.addClassify" destroy-on-close append-to-body v-model="typeDialog" width="750px">
        <avue-form :option="typeFormOption" v-model="typeForm" @submit="submitAddType" />
      </el-dialog>
      <el-dialog :title="Lang.label.addAssemblePage" destroy-on-close append-to-body v-model="pageDialog" width="750px">
        <avue-form :option="formOption" v-model="pageForm" @submit="submitAddPage" />
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import { getDeptTree } from '@/api/system/dept';
import { remove, save, update, getDetail } from '@/api/assemble/tree';

import { getDataPage, savePage, updatePage, removePage } from '@/api/assemble/index';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import func from '@/utils/func';
// import sideTree from './comps/sideTree.vue';
import { defineAsyncComponent } from 'vue'

const sideTree = defineAsyncComponent(() => import('./comps/sideTree.vue'));

export default {
  components: {
    sideTree,
  },
  data() {
    return {
      typeFormOption: {
        labelWidth: 130,
        gutter: 20,
        column: [
          {
            label: this.Lang.label.category,
            rules: [
              {
                required: true,
                trigger: 'click',
                message: this.Lang.tips.inputCategory,
              },
            ],
            prop: 'name',
          },
        ],
      },
      typeDialog: false,
      productLayoutDialogVisible: false,
      typeForm: {},
      pageDialog: false,
      showIframe: false,
      addPageOptions: {},
      pageForm: {},
      form: {},
      pageData: [],
      deptTreeData: {},
      treeForm: {},
      search: {},
      excelBox: false,
      addTableDialog: false,
      auditMode: false,
      selectionList: [],
      query: {},
      data: [], // 接口获取原始数据图表使用
      tableData: [], // 组装好的表格使用数据
      loading: true,
      parentId: '', // 分类ID
      groupId: '', // 分组
      operationType: 'add',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      treeDeptId: '',
      treeData: [],
      formOption: {
        labelWidth: 130,
        gutter: 20,
        column: [
          {
            label: '名称',
            rules: [
              {
                required: true,
                trigger: 'click',
                message: this.Lang.tips.inputName,
              },
            ],
            prop: 'viewName',
          },
          // {
          //   label: '状态',
          //   props: {
          //     label: 'title',
          //     value: 'codes',
          //   },
          //   type: 'tree',
          //   lazy: false,
          //   dataType: 'string',
          //   slot: true,
          //   prop: 'isEdit',
          //   // dicUrl: '/blade-system/dict/dictionary?code=pageStatus',
          //   dicData: [
          //     { dictKey: '1', dictValue: '建设中' },
          //     { dictKey: '2', dictValue: '已发布' },
          //   ],
          //   props: {
          //     label: 'i18nValue',
          //     value: 'dictKey',
          //   },
          //   rules: [
          //     {
          //       required: true,
          //       message: '请选择状态',
          //       trigger: 'blur',
          //     },
          //   ],
          //   span: 12,
          // },
          {
            label: this.Lang.label.orgOf,
            props: {
              label: 'title',
              value: 'codes',
            },
            treeLoad: function (node, resolve) {
              const param = this.getDeptParam();
              getDeptTree(param).then(res => {
                resolve(
                  res.data.data.map(item => {
                    return {
                      ...item,
                      leaf: !item.hasChildren,
                    };
                  })
                );
              });
            },
            type: 'tree',
            lazy: false,
            dataType: 'string',
            slot: true,
            prop: 'deptId',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectOrg,
                trigger: 'blur',
              },
            ],
            span: 12,
          },
        ],
      },
      option: {
        height: 'auto',
        calcHeight: 96,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        grid: true,
        gridBackground: '#ffffff',
        selection: false,
        dialogClickModal: false,
        column: [
          {
            label: '名称',
            rules: [
              {
                required: true,
                trigger: 'click',
                message: this.Lang.tips.inputName,
              },
            ],
            prop: 'viewName',
          },
          {
            label: 'ID',
            rules: [
              {
                required: true,
                trigger: 'click',
                message: this.Lang.tips.inputName,
              },
            ],
            prop: 'id',
            editDisplay: false,
          },
          {
            label: this.Lang.label.orgOf,
            hide: true,
            props: {
              label: 'title',
              value: 'codes',
            },
            treeLoad: function (node, resolve) {
              const param = this.getDeptParam();
              getDeptTree(param).then(res => {
                resolve(
                  res.data.data.map(item => {
                    return {
                      ...item,
                      leaf: !item.hasChildren,
                    };
                  })
                );
              });
            },
            type: 'tree',
            lazy: false,
            dataType: 'string',
            slot: true,
            prop: 'deptId',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectOrg,
                trigger: 'blur',
              },
            ],
            span: 12,
          },
        ],
      },
      excelForm: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj[btnType+'Btn'] = true;
          if (btnType === 'delete') {
            obj.delBtn = true;
          }
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // 非租户模式默认加载管理组数据
    // if (!website.tenantMode) {
    //   this.initData(website.tenantId);
    // }
    // func.calculateHeaderHeight(this);
    this.initData(website.tenantId);
    if (!sessionStorage.getItem('hasLoadedAssemble')) { // 临时处理办法...
      sessionStorage.setItem('hasLoadedAssemble', 'true');
      location.reload()
    }
  },
  methods: {
    addPage() {
      this.pageForm = {};
      this.pageDialog = true;
    },
    submitAddType(form, done) {
      const param = this.getDeptParam();
      const params = {
        name: this.typeForm.name,
        parentId: this.parentId,
        ...this.typeForm,
        ...param,
      };
      const API = this.operationType === 'edit' ? update : save;
      API(params).then(
        () => {
          this.$emit('refresh');
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.typeDialog = false;
          done();
          this.$refs.sideTree.getTreeData();
        },
        error => {
          window.console.log(error);
          done();
        }
      );
    },
    submitAddPage(form, done) {
      const param = this.getDeptParam();
      const fields = {
        groupId: this.groupId,
        ...this.pageForm,
        ...param,
      };
      const params = {
        tenantId: '',
        groupId: 0,
        viewType: '',
        viewName: '',
        viewData: '',
        channel: 0,
        ...fields, // 
      };
      params.name = params.viewName;
      const API = this.operationType === 'edit' ? updatePage : savePage;
      API(params).then(
        () => {
          this.$emit('refresh');
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.pageDialog = false;
          done();
          this.getPageList();
        },
        error => {
          window.console.log(error);
          done();
        }
      );
    },
    // 编辑报表
    handleEditTable(node) {
      this.showIframe = true;
    },
    handleEditPage(item) {
      this.pageForm = item;
      this.groupId = item.groupId;
      this.pageDialog = true;
      this.operationType = 'edit';
    },
    // 查看组态页面
    handleViewDetail(row) {
      // const url = location.origin + baseDir + `/assemble/view?id=${row.id}`;
      // window.open(url, '_blank');
      const url = this.$router.resolve(`/assemble/viewer?id=${row.id}`);
      window.open(url.href, '_blank');
    },
    // 编辑组态页面
    handleEditDetail(row) {
      // const url = location.origin + baseDir + `/assemble/editor?id=${row.id}`;
      // window.open(url, '_blank');
      const url = this.$router.resolve(`/assemble/editor?id=${row.id}`);
      window.open(url.href, '_blank');
    },
    getDeptParam() {
      const userStr = localStorage.getItem('saber-userInfo') || '{}';
      const userInfo = JSON.parse(userStr);
      const params = {
        tenantId: userInfo.content?.tenant_id,
        deptId: userInfo.content?.dept_id,
      };
      return params;
    },
    searchFirstItem(list) {
      if (list.length) {
        const firstItem = list[0] || {};
        if (firstItem.childTreeList) {
          const item = firstItem.childTreeList[0] || {};
          if (item.id) {
            this.handleTreeNodeClick(item);
          }
        }
      }
    },
    // 添加分类
    addType(row, index) {
      this.operationType = 'add';
      this.typeForm = {};
      this.typeDialog = true;
    },
    // 添加子分类
    handleAddSubType(node) {
      this.parentId = node.data.id; // 分类ID 查询和保存时用
      this.operationType = 'add';
      this.typeForm = {};
      this.typeDialog = true;
    },

    handleTreeNodeClick(data) {
      this.groupId = data.id;
      this.query.groupId = this.groupId;
    },
    // 编辑分类
    handleEditType(node) {
      this.operationType = 'edit';
      this.groupId = '';
      this.typeForm = node.data;
      this.typeForm.name = node.data.title;
      this.typeDialog = true;
    },
    // handleSearchChange(params) {
    //   this.query = Object.assign(this.query, params);
    //   this.page.currentPage = 1;
    //   this.getPageList(this.query);
    // },

    // 添加报表成功
    // handleSuccess() {
    //   this.addTableDialog = false;
    //   this.$refs.sideTree.getTreeData();
    //   this.searchReset();
    // },
    // handleSubmit(data, done, loading) {
    //   const params = {
    //     parentId: data.id,
    //     ...data,
    //   };
    //   const submitFunction = this.operationType === 'edit' ? update : save;
    //   const userInfo = this.getDeptParam();
    //   const ownerItem = findInTreeIterative(this.deptTreeData, node => node.id === userInfo.deptId);
    //   if (params.deptId != ownerItem.codes) {
    //     done();
    //     return this.$message.error(this.Lang.tips.cantSelectSuperiorDept);
    //   }
    //   submitFunction(params).then(
    //     () => {
    //       this.$emit('refresh');
    //       this.$message({
    //         type: 'success',
    //         message: this.Lang.tips.operationSuccess,
    //       });
    //       this.typeDialog = false;
    //       this.$refs.sideTree.getTreeData();
    //     },
    //     error => {
    //       window.console.log(error);
    //       loading();
    //     }
    //   );
    // },
    initData(tenantId) {
      const params = this.getDeptParam();
      getDeptTree(params).then(res => {
        const column = this.findObject(this.formOption.column, 'deptId');
        const data = res.data.data;
        column.dicData = data;
        this.deptTreeData = data;
      });
      this.searchReset();
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = Object.assign(this.query, params);
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    // 删除分类
    handleDeleteType(node) {
      const id = node.data.id;
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.sideTree.getTreeData();
        });
    },
    handleDeletePage(item) {
      const id = item.id;
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return removePage(id);
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.refreshChange();
          this.$refs.sideTree.getTreeData();
        });
    },
    // 删除报表
    handleDeleteTable(node) {
      const id = node.data.id;
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return removeReport(id);
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.sideTree.getTreeData();
          this.refreshChange();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.getPageList(this.query);
    },
    onLoad(params = {}) {
      this.getPageList(params);
    },
    getPageList(params) {
      this.loading = true;
      const page = this.page;
      getDataPage(page.currentPage, page.pageSize, this.query).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>


</style>
